// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2G_53","title":"Images45_title__5PZ9M","images":"Images45_images__2sYJ_"};